import { Directive, ElementRef, Inject, OnInit } from '@angular/core';
import { Theme, THEME_TOKEN } from '../../types/theme.types';
import { componentStylesByTheme } from '../../utils/theme.utils';
import { style } from '../../utils/style.utils';
import {
  checkboxLabelStylesSAG,
  checkboxLabelStylesSHS,
} from './checkbox-label.styles';

@Directive({
  selector: 'label[sag-ui-checkbox-label]',
})
export class CheckboxLabelDirective implements OnInit {
  constructor(
    @Inject(THEME_TOKEN) private readonly theme: Theme,
    private readonly elementRef: ElementRef<HTMLSpanElement>
  ) {}

  ngOnInit(): void {
    const checkboxLabelStyles = componentStylesByTheme(
      this.theme,
      checkboxLabelStylesSAG,
      checkboxLabelStylesSHS
    );
    style(this.elementRef, checkboxLabelStyles());
  }
}
